var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 d-flex justify-content-center align-items-center bold",class:_vm.$style.empty},[_c('span',[_vm._t("default")],2)])
}]

export { render, staticRenderFns }